
import TrackerBase from './tracker-base.vue'
import ExternalLink from 'components/external-link'
import {Column, TableHead} from 'components/data-table'
import {trackerLinkedin} from './tracker-defs'

export default {
  components: {TrackerBase, Column, TableHead, ExternalLink},
  props: {
    widget: {type: Object, required: true}
  },
  methods: {
    linkedin(entity) {
      return trackerLinkedin(entity, 'company')
    }
  }
}
